import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React, { Component } from 'react';
import { List, Button, Input, Label } from 'semantic-ui-react';
import * as API from '../../../utils/api';
import { cleanDomainName } from '../../../utils/urls';
var defaultProps = {};

var DomainSearchForm = /*#__PURE__*/function (_Component) {
  _inherits(DomainSearchForm, _Component);

  var _super = _createSuper(DomainSearchForm);

  function DomainSearchForm(props) {
    var _this;

    _classCallCheck(this, DomainSearchForm);

    _this = _super.call(this, props);
    _this.state = {
      domain: '',
      loading: false,
      results: [],
      numShowResults: 5,
      numShowIncrement: 5
    };
    _this.searchDomains = _this.searchDomains.bind(_assertThisInitialized(_this));
    _this.handleDomainChange = _this.handleDomainChange.bind(_assertThisInitialized(_this));
    _this.handleDomainClick = _this.handleDomainClick.bind(_assertThisInitialized(_this));
    _this.showMoreResults = _this.showMoreResults.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DomainSearchForm, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var defaultDomain;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                defaultDomain = this.props.defaultDomain;
                this.setState({
                  domain: cleanDomainName(defaultDomain)
                }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return _this2.searchDomains();

                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "handleDomainChange",
    value: function handleDomainChange(e, _ref2) {
      var value = _ref2.value;
      this.setState({
        domain: cleanDomainName(value)
      });
    }
  }, {
    key: "handleDomainClick",
    value: function handleDomainClick(domain) {
      var onDomainSelected = this.props.onDomainSelected;

      if (domain.Availability === 'AVAILABLE') {
        onDomainSelected(domain);
      }
    }
  }, {
    key: "searchDomains",
    value: function searchDomains() {
      var _this3 = this;

      var re = /[^.]*\.[^.]{2,3}(?:\.[^.]{2,3})?$/;
      var domain = this.state.domain;
      var match = domain.match(re);
      var finalDomain = !match ? "".concat(domain, ".com") : match[0];
      this.setState({
        loading: true
      }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var resp, data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return API.searchDomains(finalDomain);

              case 3:
                resp = _context3.sent;
                data = resp.data;

                _this3.setState({
                  loading: false,
                  results: data
                });

                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);

                _this3.setState({
                  loading: false
                });

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 8]]);
      })));
    }
  }, {
    key: "showMoreResults",
    value: function showMoreResults() {
      var _this$state = this.state,
          numShowResults = _this$state.numShowResults,
          numShowIncrement = _this$state.numShowIncrement,
          results = _this$state.results;
      var nextNumShowResults = results.length > numShowResults + numShowIncrement ? numShowResults + numShowIncrement : results.length;
      this.setState({
        numShowResults: nextNumShowResults
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$state2 = this.state,
          results = _this$state2.results,
          domain = _this$state2.domain,
          loading = _this$state2.loading,
          numShowResults = _this$state2.numShowResults;
      var onHasCustomDomainChanged = this.props.onHasCustomDomainChanged;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Input, {
        className: "domain-search-input",
        type: "text",
        placeholder: "Find Domain",
        labelPosition: "left",
        value: domain,
        onChange: this.handleDomainChange
      }, /*#__PURE__*/React.createElement(Label, {
        className: "https-label domain-search-input-consistent-padding"
      }, "https://"), /*#__PURE__*/React.createElement("input", {
        className: "borderless-input domain-search-input-consistent-padding",
        value: domain
      }), /*#__PURE__*/React.createElement(Button, {
        className: "domain-search-button",
        type: "submit",
        onClick: this.searchDomains,
        loading: loading
      }, "Search")), /*#__PURE__*/React.createElement(Button, {
        id: "custom-domain-connect-button",
        className: "publish-now-from-request-button extra-margin centered-content blue-color",
        onClick: function onClick() {
          return onHasCustomDomainChanged();
        }
      }, "I already own a domain to connect"), results.length > 0 && /*#__PURE__*/React.createElement("h3", {
        className: "header-text blue-color domain-search-header"
      }, "Suggested results:"), /*#__PURE__*/React.createElement(List, {
        className: "domain-results",
        divided: true,
        verticalAlign: "middle"
      }, results.slice(0, numShowResults).map(function (result, index) {
        return /*#__PURE__*/React.createElement(List.Item, {
          className: "domain-search-result".concat(result.Availability !== 'AVAILABLE' ? ' domain-unavailable' : ''),
          key: result.DomainName,
          onClick: function onClick() {
            return _this4.handleDomainClick(results[index]);
          }
        }, /*#__PURE__*/React.createElement(List.Content, {
          className: "domain-search-result-label"
        }, result.DomainName), result.Availability === 'AVAILABLE' ? /*#__PURE__*/React.createElement(List.Content, null, /*#__PURE__*/React.createElement("p", {
          className: "green-color domain-search-free-label"
        }, "FREE")) : /*#__PURE__*/React.createElement(List.Content, null, /*#__PURE__*/React.createElement("p", {
          className: "red-color domain-search-free-label"
        }, "Unavailable")));
      })), results.length > 0 && numShowResults !== results.length && /*#__PURE__*/React.createElement(Button, {
        onClick: this.showMoreResults,
        className: "centered-button more-results-button"
      }, "Load more results"));
    }
  }]);

  return DomainSearchForm;
}(Component);

DomainSearchForm.defaultProps = defaultProps;
export default DomainSearchForm;